import { handleActions } from 'redux-actions';

import { SELECTED_VIDEO_ACTIONS } from 'widget/redux/client/actions/select-video';
import { NAMES as VIDEO_PLAYBACK_ACTIONS } from 'widget/redux/client/actions/change-playback-status';


function markAsTouched() {
  return true;
}

function markAsNotTouched() {
  return false;
}

export default handleActions({
  [SELECTED_VIDEO_ACTIONS.SET]: markAsTouched,
  [SELECTED_VIDEO_ACTIONS.RESET]: markAsNotTouched,
  [VIDEO_PLAYBACK_ACTIONS.REQUEST_PLAY]: markAsTouched,
}, false);



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/is-videos-touched.js